export default "__VITE_ASSET__Dx_e_cww__"